/* eslint-disable prefer-destructuring */
import { post } from 'axios/index';
import Core6RowAjax from './Core6RowAjax';
import Core6Utilities from './Core6Utilities';
import Core6PagedSlider from './Core6PagedSlider';

export default class Core6RowNudging {
  static nudgeUp(rowId) {
    // console.log('nudgeUp');
    let currItem = $(`.core6-mainrow-container[data-row-id=${rowId}]:not(.isTemplate)`);
    if (currItem.hasClass('pagedsliderblock')) {
      currItem = Core6PagedSlider.getFirstPagedSlider();
      const allPagedSliders = Core6PagedSlider.getAllPagedSliders();
      const prevItem = Core6RowNudging.getPrevBlock(currItem);
      allPagedSliders.insertBefore(prevItem);
      Core6RowAjax.saveAfterNudge();
    } else {
      // const prevItem = currItem.prev();
      const prevItem = Core6RowNudging.getPrevBlock(currItem);
      // console.log(prevItem);
      currItem.insertBefore(prevItem);
      Core6RowAjax.saveAfterNudge();
    }
  }

  static nudgeDown(rowId) {
    // console.log('nudgeDown');

    let currItem = $(`.core6-mainrow-container[data-row-id=${rowId}]:not(.isTemplate)`);
    if (currItem.hasClass('pagedsliderblock')) {
      currItem = Core6PagedSlider.getFirstPagedSlider();
      const allPagedSliders = Core6PagedSlider.getAllPagedSliders();
      let nextItem;
      if (Core6PagedSlider.getLastIndex() > 0) {
        nextItem = Core6RowNudging.getNextBlock(currItem).next();
      } else {
        nextItem = Core6RowNudging.getNextBlock(currItem);
      }
      allPagedSliders.insertAfter(nextItem);
      Core6RowAjax.saveAfterNudge();
    } else {
      const nextItem = Core6RowNudging.getNextBlock(currItem);
      // console.log(nextItem);
      currItem.insertAfter(nextItem);
      Core6RowAjax.saveAfterNudge();
    }
  }

  static getNextBlock(item) {
    if (item !== undefined && item !== null) {
      let nextBlock = item.next();
      if (nextBlock !== undefined && nextBlock !== null) {
        if (nextBlock.hasClass('pagedsliderblock')) {
          nextBlock = Core6RowNudging.getNextBlock(nextBlock);
          if (!nextBlock.hasClass('pagedsliderblock')) {
            // Go back one - we're inserting after the last pagedsliderblock
            nextBlock = nextBlock.prev();
          }
        }
      }
      return nextBlock;
    }
    return null;
  }

  static getPrevBlock(item) {
    if (item !== undefined && item !== null) {
      console.log('is not null');
      let prevBlock = item.prev();
      if (prevBlock !== undefined && prevBlock !== null) {
        console.log('is still not null');
        if (prevBlock.hasClass('pagedsliderblock')) {
          console.log('is paged slider, get prev...');
          prevBlock = Core6RowNudging.getPrevBlock(prevBlock);
          if (!prevBlock.hasClass('pagedsliderblock')) {
            // Go back one - we're inserting before the first pagedsliderblock
            prevBlock = prevBlock.next();
          }
        }
      }
      return prevBlock;
    }
    return null;
  }

  static refreshNudgeArrows() {
    let pagedSliderDone = false;
    let pagedSliderUpVisible = false;
    let pagedSliderDownVisible = false;
    console.log('refresh nudge arrows');
    // const mainRows = Core6Utilities.getElementAll('.core6-mainrow-container:not(.isTemplate)');
    const mainRows = Core6Utilities.getJQueryElement('.core6-mainrow-container:not(.isTemplate)');
    for (let i = 0, len = mainRows.length; i < len; i += 1) {
      const row = $(mainRows[i]);
      if (row.attr('block_locked') === true) {
        row.find('[data-core6-action="nudgeBlockUp"]').parent().css('display', 'none');
        row.find('[data-core6-action="nudgeBlockDown"]').parent().css('display', 'none');
      } else if (row.hasClass('pagedsliderblock')) {
        if (pagedSliderDone === false) {
          const prevItem = Core6RowNudging.getPrevBlock(row);
          let nextItem;
          if (Core6PagedSlider.getLastIndex() > 0) {
            nextItem = Core6RowNudging.getNextBlock(row).next();
          } else {
            nextItem = Core6RowNudging.getNextBlock(row);
          }

          if (prevItem === null || prevItem.hasClass('isTemplate')) {
            row.find('[data-core6-action="nudgeBlockUp"]').parent().css('display', 'none');
            pagedSliderUpVisible = false;
          } else {
            row.find('[data-core6-action="nudgeBlockUp"]').parent().css('display', 'block');
            pagedSliderUpVisible = true;
          }

          if (nextItem === null || nextItem.hasClass('isTemplate')) {
            row.find('[data-core6-action="nudgeBlockDown"]').parent().css('display', 'none');
            pagedSliderDownVisible = false;
          } else {
            row.find('[data-core6-action="nudgeBlockDown"]').parent().css('display', 'block');
            pagedSliderDownVisible = true;
          }

          pagedSliderDone = true;
        } else {
          if (pagedSliderUpVisible === false) {
            row.find('[data-core6-action="nudgeBlockUp"]').parent().css('display', 'none');
          } else {
            row.find('[data-core6-action="nudgeBlockUp"]').parent().css('display', 'block');
          }

          if (pagedSliderDownVisible === false) {
            row.find('[data-core6-action="nudgeBlockDown"]').parent().css('display', 'none');
          } else {
            row.find('[data-core6-action="nudgeBlockDown"]').parent().css('display', 'block');
          }
        }
      } else {
        const prevItem = Core6RowNudging.getPrevBlock(row);
        const nextItem = Core6RowNudging.getNextBlock(row);

        if (prevItem === null || prevItem.hasClass('isTemplate')) {
          row.find('[data-core6-action="nudgeBlockUp"]').parent().css('display', 'none');
        } else {
          row.find('[data-core6-action="nudgeBlockUp"]').parent().css('display', 'block');
        }

        if (nextItem === null || nextItem.hasClass('isTemplate')) {
          row.find('[data-core6-action="nudgeBlockDown"]').parent().css('display', 'none');
        } else {
          row.find('[data-core6-action="nudgeBlockDown"]').parent().css('display', 'block');
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/core6/Core6RowNudging.js